/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 瞳孔反応
 */
export type PupilReactionEnum =
  (typeof PupilReactionEnum)[keyof typeof PupilReactionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PupilReactionEnum = {
  POSITIVE: 'POSITIVE',
  SLUGGISH: 'SLUGGISH',
  NEGATIVE: 'NEGATIVE',
  UNKNOWN: 'UNKNOWN',
} as const;
